import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import TitleLine from './titleLine/';
import ArticleArea from './articleArea';
import WemediaRec from './wemediaRec';
import Ad from '@ifeng/ui_pc_ad';
import LogoBox from './logoBox/';
import InIframe from './inIframe/';
import QRBox from './qrBox/';

const Content = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        state = {
            wemediaEAccountName: '',
            wemediaEAccountHead: '',
            wemediaEAccountHonorImg: '',
            wemediaEAccountHonorName: '',
            wemediaEAccountDesc: '',
        };

        showHonorName = () => {
            this.setState({
                honorNameShow: true,
            });
        };

        hideHonorName = () => {
            this.setState({
                honorNameShow: false,
            });
        };

        async componentDidMount() {
            const {
                content: {
                    docData: { wemediaEAccountId },
                    wemediaDetail,
                },
            } = this.props;

            // if (title) {
            //     document.title = title;
            // }

            if (wemediaEAccountId) {
                const { description = '', honorImg = '', honorName = '', logo = '', weMediaName = '' } = wemediaDetail;

                this.setState({
                    wemediaEAccountName: weMediaName,
                    wemediaEAccountHead: logo,
                    wemediaEAccountDesc: description,
                    wemediaEAccountHonorImg: honorImg,
                    wemediaEAccountHonorName: honorName,
                });
            }
        }

        render() {
            const {
                content: {
                    type,
                    docData,
                    docData: {
                        title,
                        newsTime,
                        wemediaEAccountId,
                        videosPluginData,
                        slidesPluginData,
                        surveyPluginData,
                    },
                    recWeChatQrCode,
                    brandLogo,
                    qrCodeLogo,
                    ad_right_rec1,
                    ad_right_rec2,
                    ad_right_rec3,
                    ad_content_banner1,
                    ad_content_banner2,
                    rightGameAd,
                },
            } = this.props;

            const pluginData = {
                videosPluginData,
                slidesPluginData,
                surveyPluginData,
            };

            const articleAdData = {
                ad_content_banner1,
                ad_content_banner2,
            };

            const {
                wemediaEAccountName,
                wemediaEAccountDesc,
                wemediaEAccountHead,
                wemediaEAccountHonorImg,
                wemediaEAccountHonorName,
            } = this.state;

            return (
                <div className={styles.container}>
                    <TitleLine
                        wemediaEAccountId={wemediaEAccountId}
                        wemediaEAccountInfo={{
                            wemediaEAccountName,
                            wemediaEAccountHead,
                            wemediaEAccountHonorImg,
                            wemediaEAccountHonorName,
                        }}
                        articleObj={{ title, newsTime }}
                    />
                    <div className={styles.left_articleArea}>
                        <ArticleArea
                            articleData={docData}
                            pluginData={pluginData}
                            contentAdData={articleAdData}
                            type={type}
                        />
                        {wemediaEAccountId ? (
                            <WemediaRec
                                content={{
                                    wemediaEAccountId,
                                    wemediaEAccountDesc,
                                    wemediaEAccountHead,
                                    source: wemediaEAccountName,
                                }}
                                recQrData={recWeChatQrCode}
                            />
                        ) : null}
                    </div>
                    <div className={styles.right_adArea}>
                        <Ad content={ad_right_rec1} styleName={styles.ad_square} />
                        <Chip id="45024" type="struct" title="大风号Logo" groupName="content" content={brandLogo}>
                            <LogoBox />
                        </Chip>
                        <Ad content={ad_right_rec2} styleName={styles.ad_rectangle} />
                        <Ad content={ad_right_rec3} styleName={styles.ad_rectangle} />
                        <Chip
                            id="50029"
                            type="struct"
                            title="游戏推广iframe"
                            groupName="content"
                            content={rightGameAd.url}>
                            <InIframe content={rightGameAd.url} />
                        </Chip>
                        <Chip id="65002" type="struct" title="二维码logo" groupName="content" content={qrCodeLogo}>
                            <QRBox />
                        </Chip>
                    </div>
                </div>
            );
        }
    },
);

export default Content;
